export const messages = {
  assign: 'Assign',
  assignRetailerAccount: 'Assign Retailer Account',
  enterRetailerContactEmail: (profileName) => (
    <span>
      You are not connected to{' '}
      <span className="notranslate">{profileName}</span>. Please enter your
      Retailer contact&#39;s email.
    </span>
  ),
  selectRetailer: 'Select a retailer',
  note:
    'Note: If you cannot find your retailer in the search, please ' +
    'go to the Connections page and add them as a new connection first.',
  retailerContactFound: (buyerEmail, profileName) => (
    <span>
      We found <span className="notranslate">{buyerEmail}</span> on{' '}
      <span className="notranslate">{profileName}.</span> We will automatically
      connect you to them once you assign your order(s).
    </span>
  ),
  retailerContactNotFound: (buyerEmail, profileName) => (
    <span>
      We will automatically connect you to{' '}
      <span className="notranslate">{profileName}</span> once you assign your
      order(s). <span className="notranslate">{buyerEmail}</span> will also be
      added as a contact.
    </span>
  ),
  retailerEmail: "Retailer contact's email",
  retailerNotFound: (profileName) => (
    <span>
      We didn&#39;t find <span className="notranslate">{profileName}</span> on
      our platform. Please try another retailer or chat with our support team.
    </span>
  ),
  sendConnectionRequest: (profileName) => (
    <span>
      You are not connected to{' '}
      <span className="notranslate">{profileName}</span>. You can use this form
      to send a connection request.
    </span>
  ),
  searchByEmail: 'Search by email address...',
  sendRequest: 'Send Request',
  startTyping: 'Start typing to search...',
  retailerDiscountInfo: `Changing the retailer associated with an order may result in inaccurate discount information.
     Please verify the discounts in the order to ensure accuracy.`,
  keepAddressInfo: 'Keep address information',
}
